import { createContext } from "react";

type CurrencyContextInterface = {
  currency: string;
  setCurrency: React.Dispatch<React.SetStateAction<string>>;
  allCurrencies: { id: string; value: string; symbol: string }[];
  isDataLoading: boolean;
  formatCurrency: (amount: number) => string;
};

const CurrencyContext = createContext<CurrencyContextInterface>({
  currency: "",
  setCurrency: () => {},
  allCurrencies: [],
  isDataLoading: true,
  formatCurrency: () => "",
});

export default CurrencyContext;
